import { baseApi } from '@krp/client-runtime'

import { PLATFORM_CATALOG_TAG } from '../../catalog-links/api/catalogLinksApi'
import type { CommonCatalogArgs, CommonCatalogPage } from '../model/types'
import { decodeCommonCatalogPage } from './contracts'
import { PLATFORM_COMMON_CATALOG_URLS } from './urls'

/**
 * Общий каталог в общем `baseApi` (R04): префикс `platform`, тег — тот же, что у
 * связей товаров: связывание и разрыв меняют список связей товара, и страница
 * перечитывается сама. Строка поиска и страница — аргументы, а значит и ключ кэша.
 */
export const commonCatalogApi = baseApi.enhanceEndpoints({ addTagTypes: [PLATFORM_CATALOG_TAG] }).injectEndpoints({
  endpoints: (build) => ({
    platformCatalogProducts: build.query<CommonCatalogPage, CommonCatalogArgs>({
      query: ({ query, page, pageSize }) => ({
        url: PLATFORM_COMMON_CATALOG_URLS.products,
        params: { ...(query === '' ? {} : { query }), page: String(page), pageSize: String(pageSize) },
        decode: decodeCommonCatalogPage,
      }),
      providesTags: [{ type: PLATFORM_CATALOG_TAG, id: 'PRODUCTS' }],
    }),
  }),
})

export const { platformCatalogProducts } = commonCatalogApi.endpoints
